var breakPoints = {
  xl: 1680,
  lg: 1196,
  md: 1024,
  sm: 640,
  xs: 1
};
var breakPointsMinMax = {
  xl: breakPoints.xl,
  lgMax: breakPoints.xl - 1,
  lg: breakPoints.lg,
  mdMax: breakPoints.lg - 1,
  md: breakPoints.md,
  smMax: breakPoints.md - 1,
  sm: breakPoints.sm,
  xsMax: breakPoints.sm - 1,
  xs: breakPoints.xs
};

function getViewportMediaQuery(viewport, direction) {
  var min = direction === "min" || direction === "exact" ? breakPointsMinMax[viewport] : undefined;
  var max = direction === "max" || direction === "exact" ? breakPointsMinMax["".concat(viewport, "Max")] : undefined;
  return [min ? "(min-width: ".concat(min, "px)") : "", max ? "(max-width: ".concat(max, "px) ") : ""].filter(function (mq) {
    return !!mq;
  }).join(" and ");
}

var getViewportMediaQuerySmMin = function getViewportMediaQuerySmMin() {
  return getViewportMediaQuery("sm", "min");
};

var getViewportMediaQueryMdMin = function getViewportMediaQueryMdMin() {
  return getViewportMediaQuery("md", "min");
};

var getViewportMediaQueryLgMin = function getViewportMediaQueryLgMin() {
  return getViewportMediaQuery("lg", "min");
};

var getViewportMediaQueryXlMin = function getViewportMediaQueryXlMin() {
  return getViewportMediaQuery("xl", "min");
};

var getViewportMediaQueryXsExact = function getViewportMediaQueryXsExact() {
  return getViewportMediaQuery("xs", "exact");
};

function getViewportMediaQueryRange(minViewport, maxViewport) {
  return "(min-width: ".concat(breakPointsMinMax[minViewport], "px) and (max-width: ").concat(breakPointsMinMax["".concat(maxViewport, "Max")], "px)");
}

export { breakPoints, getViewportMediaQuery, getViewportMediaQueryLgMin, getViewportMediaQueryMdMin, getViewportMediaQueryRange, getViewportMediaQuerySmMin, getViewportMediaQueryXlMin, getViewportMediaQueryXsExact };
